import React, {useMemo} from "react";
import {AgGridReact} from "ag-grid-react";
import {FaPen} from "react-icons/fa";
import aggridUtils from "../../../../../utils/aggrid-utils.js";
import {DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL} from "../../../../../utils/ag-grid-columns-utils.js";
import {activityLinkUrl} from "../utils/activity-utils.js";
import ActivityLink from "./activity-link.jsx";
import InputForm from "../../../../../components/input/input-form.jsx";

const diffStyle = (isDiff) => (isDiff ? {color: "#dc2626", fontWeight: 600} : null);

const EditableHeader = ({displayName}) => (
    <span className="flex items-center gap-1.5">
        <FaPen size={11} className="text-gray-500"/>
        {displayName}
    </span>
);

const ActivityBoTable = ({bos, onChangeObservation, boName}) => {
    const hasDiff = bos.some(item => item.diffNature || item.diffNeighborhood);

    const columnDefs = useMemo(() => [
        {
            field: "numberCheckbook", headerName: "Despacho", width: 140,
            comparator: aggridUtils.agGridNumberYearComparator,
            cellRenderer: ({data, value}) => (
                <ActivityLink to={activityLinkUrl.dispatch(data?.dispatchId)}>{value ?? ""}</ActivityLink>
            ),
        },
        {
            field: "bogcmId", headerName: boName, width: 140,
            comparator: aggridUtils.agGridNumberYearComparator,
            cellRenderer: ({value}) => (
                <ActivityLink to={activityLinkUrl.bo(value)}>{value ?? ""}</ActivityLink>
            ),
        },
        {field: "namewar", headerName: "Responsável", flex: 1},
        {
            colId: "nature", headerName: "Natureza", flex: 1,
            valueGetter: ({data}) => `${(data.nature ?? []).join(", ")}${data.diffNature ? " *" : ""}`,
            cellStyle: ({data}) => data?.diffNature ? {color: "#dc2626"} : null,
        },
        {
            colId: "neighborhood", headerName: "Bairro", flex: 1,
            valueGetter: ({data}) => `${data.neighborhood ?? ""}${data.diffNeighborhood ? " *" : ""}`,
            cellStyle: ({data}) => diffStyle(data?.diffNeighborhood),
        },
        {
            field: "tags", headerName: "Marcadores", flex: 1,
            cellRenderer: ({ value }) => (
                <span>
                    {value?.map(tag => tag.label).join(", ") ?? ""}
                </span>
            ),
            tooltipValueGetter: ({ value }) => value?.map(tag => tag.label).join(", ") ?? "",
        },
        {
            field: "bosObservation", headerName: "Breve histórico", flex: 2,
            sortable: false,
            headerComponentParams: {innerHeaderComponent: EditableHeader},
            cellRenderer: ({data, value}) => (
                <InputForm
                    classNameWrapper="w-full mt-1"
                    inputClass="text-[15px]!"
                    id={`bo-observation-${data.bogcmId}`}
                    label=""
                    defaultValue={value ?? ""}
                    onChange={({target: {value}}) => onChangeObservation(data.bogcmId, value)}
                />
            ),
        },
    ], [boName, onChangeObservation]);

    return (
        <div>
            <AgGridReact
                domLayout="autoHeight"
                rowData={bos}
                columnDefs={columnDefs}
                defaultColDef={DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL}
                getRowId={({data}) => String(data.bogcmId)}
                animateRows={false}
                gridOptions={{localeText: aggridUtils.localization()}}
                theme={aggridUtils.generalTheme({rowHeight: 40}).withParams({headerFontSize: 13, fontSize: 14})}
                overlayNoRowsTemplate="Nenhum registro."
            />
            {hasDiff &&
                <div className="mt-2 text-xs text-red-600">
                    * Informação referente ao {boName} diverge da informação do despacho.
                </div>
            }
        </div>
    );
};

export default ActivityBoTable;
